// Mock data for portfolio
import profilePic from '../assets/profile.png';
export const personalInfo = {
  name: "Arpan Jain",
  uniqueCode: "AJ001",
  title: "CSE Student @GLA University",
  headline: "Full-stack Developer || Python Developer || Java Developer",
  tagline: "Building scalable web applications with modern technologies",
  profileImage: profilePic,
  resumeLink: "/resume/Arpan_Jain_BTech_CSE_Resume.pdf",
  email: "arpanjain00123@gmail.com",
  phone: "+91 6399003541",
  location: "Mathura, India",
  linkedin: "https://www.linkedin.com/in/arpan-jain-42386b2a7",
  github: "https://github.com/Arpan-jain001",
  bio: "Passionate Computer Science student with hands-on experience in full-stack development, cloud technologies, and open-source contributions. Completed 434+ cloud labs and earned Google Cloud Arcade Legend tier. Active contributor in GSSoC'25 and SSOC'4."
};

export const skills = [
  { name: "React.js", category: "Frontend", level: 90 },
  { name: "Node.js", category: "Backend", level: 85 },
  { name: "Python", category: "Backend", level: 88 },
  { name: "Java", category: "Backend", level: 82 },
  { name: "MongoDB", category: "Database", level: 85 },
  { name: "Express.js", category: "Backend", level: 87 },
  { name: "HTML5/CSS3", category: "Frontend", level: 95 },
  { name: "JavaScript", category: "Frontend", level: 90 },
  { name: "Tailwind CSS", category: "Frontend", level: 92 },
  { name: "Git/GitHub", category: "Tools", level: 88 },
  { name: "REST APIs", category: "Backend", level: 86 },
  { name: "Google Cloud", category: "Cloud", level: 85 },
];

export const experiences = [
  {
    id: 1,
    role: "Full Stack Developer Intern & Mentee",
    company: "W3grads",
    period: "Jun 2025 - Jul 2025",
    description: "Completed JOVAC'25 Smart Full Stack Internship Program and continued as a mentee, learning full-stack development across frontend, backend, database management, deployment, version control, and API integration.",
    skills: ["React.js", "Node.js", "Express.js", "MongoDB", "REST APIs", "Version Control", "API Integration"]
  },
  {
    id: 2,
    role: "Web Developer Intern",
    company: "Zidio Development",
    period: "Jan 2025 - Mar 2025",
    description: "Worked on web development projects using modern frontend technologies and responsive design principles.",
    skills: ["HTML", "CSS", "JavaScript", "React.js"]
  },
  {
    id: 3,
    role: "Java Developer Intern",
    company: "CodSoft",
    period: "Jun 2024 - Jul 2024",
    description: "Enhanced Java programming skills through practical project development and implementation.",
    skills: ["Java", "OOP", "Data Structures"]
  },
];

export const projects = [
  {
    id: 5,
    title: "Rozgar Mitra India",
    category: "Freelance Client Project",
    period: "Aug 2026 - Present",
    description: "A web-based employment and accommodation assistance platform built from client requirements to connect local job seekers, employers, and room/PG owners in one digital ecosystem.",
    mission: "To simplify local employment and safe accommodation discovery through a trusted role-based platform.",
    role: "Handled client requirement analysis, frontend and backend development, API integration, database design, role-based dashboards, deployment setup, testing, and bug fixing.",
    features: ["Candidate job applications", "Employer hiring workflow", "Room/PG listings", "Visit requests and bookings", "Rent management", "Admin verification", "Email OTP and Google login", "Real-time notifications"],
    image: "/projects/rozgar-mitra-logo.png",
    technologies: ["React.js", "Node.js", "Express.js", "MongoDB", "Tailwind CSS", "Socket.IO", "JWT", "Cloudinary"],
    liveLink: "https://rozgarmitra-india.com/",
    previewImage: "/projects/rozgar-preview.png",
    githubLink: "",
    featured: true
  },
  {
    id: 6,
    title: "PulseIQ",
    category: "AI-Powered Analytics SaaS",
    period: "Feb 2026 - Apr 2026",
    description: "An AI-powered website and app analytics SaaS that helps businesses understand not just what users do, but why they do it through behavioral intelligence.",
    mission: "To empower businesses with AI-driven behavioural intelligence.",
    role: "Project Lead & Coordinator; contributed across SaaS dashboards, authentication, workspace flows, analytics APIs, AI insight surfaces, and product planning.",
    features: ["Real-time event tracking", "Funnel drop analysis", "Retention analytics", "AI insights engine", "Analytics chatbot", "API key management", "Role-based access", "Exam platform analytics"],
    image: "/projects/pulseiq-favicon.png",
    technologies: ["React.js", "Node.js", "Express.js", "MongoDB", "Tailwind CSS", "Framer Motion", "OpenAI/Gemini API"],
    liveLink: "https://pulseiqai.netlify.app/",
    previewImage: "/projects/pulseiq-preview.png",
    githubLink: "",
    featured: true
  },
  {
    id: 7,
    title: "CampusFlow App",
    category: "Mobile App",
    period: "Dec 2025 - Jan 2026",
    description: "An all-in-one college life planner that organizes classes, tasks, quizzes, exams, events, and notices in one clean timeline.",
    mission: "To replace scattered WhatsApp chats, notes, and screenshots with one organized student productivity app.",
    role: "Designed and shipped a mobile-first planning experience with OTP-secured accounts, device-safe progress, and education workflow management.",
    features: ["Class planner", "Tasks and quizzes", "Exam schedule", "Events and notices", "Clean timeline", "OTP-secured accounts", "Cross-device data access"],
    image: "/projects/campusflow-preview.png",
    technologies: ["JavaScript", "React Native", "Expo SDK 54", "Expo Router", "Node.js", "Express.js", "MongoDB", "SendGrid Email API", "TypeScript", "Firebase"],
    liveLink: "https://www.indusappstore.com/apps/education/campusflow/com.aj001.campusflow/?page=details&id=com.aj001.campusflow",
    previewImage: "/projects/campusflow-preview.png",
    githubLink: "",
    featured: false
  },
  {
    id: 8,
    title: "Jain Mandir Parham",
    category: "Freelance Client Project",
    period: "Jun 2026 - Jul 2026",
    description: "A deployed website for Bada Jain Mandir Parham with a clean public web presence.",
    role: "Built and deployed the public website experience.",
    features: ["Temple website", "Responsive pages", "Public deployment"],
    image: "/projects/jainmandir-preview.png",
    technologies: ["React.js", "Node.js", "Express.js", "MongoDB", "Responsive UI"],
    liveLink: "https://jainmandirparham.netlify.app/",
    previewImage: "/projects/jainmandir-preview.png",
    githubLink: "",
    featured: false
  },
  {
    id: 9,
    title: "Bada Jain Mandir Parham App",
    category: "Freelance Client Project",
    period: "Jul 2026 - Present",
    description: "A React Native devotional mobile app for Bada Jain Mandir Parham with backend-powered communication, notifications, and receipt generation.",
    role: "Built and shipped the mobile app with Node.js, Express.js, and MongoDB backend support, email workflows, push notifications, and PDF receipt generation.",
    features: ["Devotional app", "Published app listing", "Mobile access", "Email notifications", "Firebase push notifications", "PDF receipt generation", "Backend APIs"],
    image: "/projects/jainmandir-app-preview.png",
    technologies: ["React Native", "Node.js", "Express.js", "MongoDB", "Resend", "Firebase", "PDFKit", "Mobile App"],
    liveLink: "https://www.indusappstore.com/apps/devotional/bada-jain-mandir-parham/com.parham.jainmandir/?page=details&id=com.parham.jainmandir",
    previewImage: "/projects/jainmandir-app-preview.png",
    githubLink: "",
    featured: false
  },
  {
    id: 1,
    title: "UrbanTales E-Commerce",
    category: "Award-Winning eCommerce Platform",
    period: "Jul 2025 - Oct 2025",
    description: "A full-stack e-commerce ecosystem focused on simple, secure shopping with customer, seller, and admin portals.",
    mission: "To create a hassle-free, accessible, and highly secure e-commerce experience that puts users first.",
    role: "Developed and maintained the platform as a full-stack developer, working on customer shopping flows, seller management, admin operations, authentication, payments, and order tracking.",
    features: ["Customer storefront", "Seller onboarding", "Seller dashboard", "Admin KPI dashboard", "Firebase authentication", "Google login", "Razorpay payments", "Order tracking", "Promotions and banners", "Broadcast notifications"],
    image: "/projects/urbantales.png",
    technologies: ["React.js", "Node.js", "Express.js", "MongoDB", "Tailwind CSS", "Firebase", "Razorpay", "Google OAuth"],
    liveLink: "https://urbantales-ecommerce.in/",
    previewImage: "/projects/urbantales-preview.png",
    githubLink: "https://github.com/Arpan-jain001",
    featured: true
  },
  {
    id: 2,
    title: "Quiz Application",
    category: "Frontend Project",
    description: "Interactive quiz application with multiple categories, timer functionality, and score tracking system. Built with vanilla JavaScript for optimal performance.",
    role: "Built the UI, quiz flow, timer, scoring, and browser storage behavior.",
    features: ["Quiz categories", "Timer", "Score tracking", "Local storage"],
    image: "/projects/quiz-preview.svg",
    technologies: ["HTML5", "CSS3", "JavaScript", "Local Storage"],
    liveLink: "https://arpan-jain001.github.io/special_quiz_session/",
    githubLink: "https://github.com/Arpan-jain001/special_quiz_session",
    featured: true
  },
  {
    id: 3,
    title: "Weather App with React",
    category: "React Project",
    description: "Real-time weather application using OpenWeather API. Displays current weather, forecasts, and location-based data with beautiful UI.",
    role: "Built the React interface and integrated weather API data.",
    features: ["Weather lookup", "API integration", "Responsive UI"],
    image: "/projects/weather-preview.svg",
    technologies: ["React.js", "OpenWeather API", "CSS3"],
    liveLink: "#",
    githubLink: "https://github.com/Arpan-jain001",
    featured: false
  },
  {
    id: 4,
    title: "Spring Boot Application",
    category: "Java Backend Project",
    description: "First application built with Spring Boot and Thymeleaf. Demonstrates backend development skills with Java ecosystem.",
    role: "Practiced backend structure, Java application flow, and Thymeleaf rendering.",
    features: ["Java backend", "Server-rendered views", "Spring Boot setup"],
    image: "/projects/spring-preview.svg",
    technologies: ["Spring Boot", "Thymeleaf", "Java", "Maven"],
    liveLink: "#",
    githubLink: "https://github.com/Arpan-jain001",
    featured: false
  }
];

export const achievements = [
  {
    id: 6,
    title: "UrbanTales - 1st Prize",
    organization: "S3 Summer Synergy Showcase 2026",
    date: "2 Feb 2026",
    description: "UrbanTales won 1st Prize at S3 Summer Synergy Showcase 2026 at GLA University, Mathura.",
    image: "/projects/urbantales-prize.jpeg",
    highlights: [
      "1st Prize Winner",
      "S3 Summer Synergy Showcase 2026",
      "Rs. 11,000 Prize"
    ]
  },
  {
    id: 1,
    title: "Google Cloud Arcade LEGEND Tier",
    organization: "Google Cloud",
    date: "2025",
    description: "Achieved Legend Tier in Google Cloud Skills Boost Arcade with 434 hands-on labs, 72 courses, 81 quizzes, and 31 games completed.",
    image: "/certificates/google cloud swag tier legend prize counter.jpeg",
    highlights: [
      "434 Hands-on Labs Completed",
      "72 Courses Finished",
      "81 Quizzes Passed",
      "31 Games Developed"
    ]
  },
  {
    id: 2,
    title: "GSSoC 2025 Campus Ambassador",
    organization: "GirlScript Foundation",
    date: "2025",
    description: "Selected as Campus Ambassador for GirlScript Summer of Code 2025. Promoting open-source awareness and mentoring students.",
    image: "/certificates/campus ambasaddor at GSSoC 25.jpeg",
    highlights: [
      "Campus Ambassador",
      "Open Source Mentorship",
      "Community Building"
    ]
  },
  {
    id: 3,
    title: "SSOC'4 Contributor",
    organization: "Social Summer of Code",
    date: "2025",
    description: "Contributing to open-source projects and engaging with cutting-edge technologies.",
    image: "/certificates/contributor ssoc.jpeg",
    highlights: [
      "Open Source Contributions",
      "Technical Collaboration"
    ]
  },
  {
    id: 4,
    title: "NCAT 2025 - Top 96.35 Percentile",
    organization: "Naukri Campus",
    date: "May 2025",
    description: "Scored 48/60 overall in India's Biggest Career Aptitude Test with 93.21% in Quantitative Aptitude and 92.16% in Data Interpretation.",
    image: "/certificates/certificate of participation naukari campus.jpeg",
    highlights: [
      "Overall Score: 48/60",
      "96.35% in Engineering 2027",
      "93.21% in Quantitative Aptitude"
    ]
  },
  {
    id: 5,
    title: "IIT Roorkee Cognizance 2025",
    organization: "IIT Roorkee",
    date: "March 2025",
    description: "Participated in multiple tech events including Blockathon, BitByBit, Codify Rumble, and Cosmic Classifier at IIT Roorkee's tech fest.",
    image: "/certificates/articipation of Workshop on Blockchain cognizance 2025 iit roorkee.jpeg",
    highlights: [
      "Blockchain Workshop",
      "Multiple Hackathons",
      "Team Leadership"
    ]
  }
];

export const certificates = [
  { id: 22, name: "Microsoft Certified: Azure AI Fundamentals", image: "/certificates/microsoft-learn-preview.png", issuer: "Microsoft", date: "June 20, 2026" },
  { id: 23, name: "Guidwire DEVTrails University Hackathon 2026", image: "/certificates/guidwire-participation-preview.png", issuer: "Guidwire DEVTrails", date: "2026" },
  { id: 24, name: "Cognizant Technoverse Hackathon 2026", image: "/certificates/cognizant-technoverse-hackathon-2026-preview.png", issuer: "Cognizant", date: "2026" },
  { id: 25, name: "Zidio Internship Offer Letter", image: "/certificates/Zidio internship offer letter.jpeg", issuer: "Zidio Development", date: "2025" },
  { id: 26, name: "NCAT 2025", image: "/certificates/certificate of participation naukari campus.jpeg", issuer: "Naukri Campus", date: "May 2025" },
  { id: 27, name: "SSOC Contributor", image: "/certificates/contributor ssoc.jpeg", issuer: "Social Summer of Code", date: "2025" },
  { id: 1, name: "AWS Solutions Architecture Job Simulation", image: "/certificates/AWS APAC - Solutions Architecture Job Simulation certificate.jpeg", issuer: "AWS", date: "2025" },
  { id: 2, name: "Accenture Software Engineering Simulation", image: "/certificates/Accenture Nordics - Software Engineering Job Simulation.jpeg", issuer: "Accenture", date: "2025" },
  { id: 3, name: "Weather App with React & OpenWeather API", image: "/certificates/Build a Weather App with React & OpenWeather API.jpeg", issuer: "SkillEcted", date: "2025" },
  { id: 4, name: "Deloitte Technology Job Simulation", image: "/certificates/Deloitte Australia - Technology  Job Simulation.jpeg", issuer: "Deloitte", date: "2025" },
  { id: 5, name: "Spring Boot & Thymeleaf", image: "/certificates/First app with Spring Boot & Thymeleaff.png", issuer: "SkillEcted", date: "2025" },
  { id: 6, name: "Google AI Workshop", image: "/certificates/Google workshop certificat_.jpeg", issuer: "Google", date: "2025" },
  { id: 7, name: "Learning Data Analytics", image: "/certificates/Learning Data Analytics.jpeg", issuer: "LinkedIn", date: "2025" },
  { id: 8, name: "JavaScript Bootcamp", image: "/certificates/Lets upgrade certified Javascript Bootcamp.jpeg", issuer: "LetsUpgrade", date: "2024" },
  { id: 9, name: "Environmental Engineering - NPTEL", image: "/certificates/Nptel certificate.jpeg", issuer: "IIT Kharagpur", date: "2025" },
  { id: 10, name: "W3grads Internship", image: "/certificates/certificate of internship in w3grades.jpeg", issuer: "W3grads", date: "2025" },
  { id: 11, name: "IIT Roorkee - BitByBit", image: "/certificates/certificate of participation bitbybit iit roorkee.jpeg", issuer: "IIT Roorkee", date: "2025" },
  { id: 12, name: "IIT Roorkee - Blockathon", image: "/certificates/certificate of participation blocjkathon iit roorkee.jpeg", issuer: "IIT Roorkee", date: "2025" },
  { id: 13, name: "IIT Roorkee - Codify Rumble", image: "/certificates/certificate of participation codify rumble iit roorkee.jpeg", issuer: "IIT Roorkee", date: "2025" },
  { id: 14, name: "IIT Roorkee - Cosmic Classifier", image: "/certificates/certificate of participation cosmic classifier iit roorkee.jpeg", issuer: "IIT Roorkee", date: "2025" },
  { id: 15, name: "Common Internship Test", image: "/certificates/common internship test at internship studio.jpeg", issuer: "Internship Studio", date: "2024" },
  { id: 16, name: "Java Developer Internship", image: "/certificates/internship java.jpeg", issuer: "CodSoft", date: "2024" },
  { id: 17, name: "Master Diploma in Computer Application", image: "/certificates/master deploma in computer application.jpeg", issuer: "JKS Institute", date: "2024" },
  { id: 18, name: "Student Ambassador - LetsUpgrade", image: "/certificates/student ambasador at lets upgrade.jpeg", issuer: "LetsUpgrade", date: "2025" },
  { id: 19, name: "GSSoC Campus Ambassador", image: "/certificates/campus ambasaddor at GSSoC 25.jpeg", issuer: "GirlScript", date: "2025" },
  { id: 20, name: "Google Cloud Legend Prize", image: "/certificates/google cloud swag tier legend prize counter.jpeg", issuer: "Google Cloud", date: "2025" },
];

export const contactFormMock = {
  submitForm: async (formData) => {
    // Mock API call - will be replaced with actual backend
    return new Promise((resolve) => {
      setTimeout(() => {
        console.log("Mock form submission:", formData);
        resolve({ success: true, message: "Message sent successfully!" });
      }, 1500);
    });
  }
};
